export const automationLogsPath = '/automation/logs/:ruleId';

export function automationLogsLocation(ruleId, {background, ruleName, executionId, notification} = {}) {
    if (!/^[1-9]\d{0,19}$/.test(String(ruleId))) {
        return null;
    }

    if (executionId && !/^[1-9]\d{0,18}$/.test(String(executionId))) {
        return null;
    }

    const search = new URLSearchParams();
    if (executionId && /^[1-9]\d{0,18}$/.test(String(executionId))) {
        search.set('executionId', String(executionId));
    }

    return {
        pathname: `/automation/logs/${ruleId}`,
        search: search.toString() ? `?${search}` : '',
        state: {background: background?.state?.background || background, ruleName, notification}
    };
}

export function automationNotificationLocation(notification, background) {
    if (notification?.type !== 'automation_execution') {
        return null;
    }
    return automationLogsLocation(notification.data?.ruleId, {
        background, executionId: notification.data?.executionId, notification
    });
}
